class LoyaltyPoints extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const token = "a041e926117673199463f0c686908230";
    const userId = "31742";
    const customerId = this.getAttribute("data-customer-id");
    this.loader = this.querySelector(".loyalty-plan-loader");
    const apiUrl = `https://app.getflits.com/api/1/${userId}/${customerId}/credit/get_credit?token=${token}`;

    this.getData(apiUrl);
  }

  async getData(apiUrl) {
    await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-integration-app-name": "Lets_hyphen",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json(); 
      })
      .then((data)=>{
        this.updateData(data);
      })
      .catch((error) => {
        this.loader.classList.add("hidden");
        console.error("Fetch error:", error);
      });
  }

  updateData(data) {
    this.loyaltyPoints = this.querySelector(".loyalty-points");
    this.loyaltyPoints.innerHTML = data.customer.credits/100;
    this.loader.classList.add("hidden");
  }
}

customElements.define("loyalty-points", LoyaltyPoints);

